import { usersListingStore } from './users-listing/users-listing.store';

export const usersStore = {
  modules: {
    usersListingState: usersListingStore
  }
};
